import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.AttachmentsSection', {
    label: 'Files',
    uploadOcrButton: 'Upload to ApprovalMax Capture',
    capturing: 'Capturing',
});
